declare global {
    interface Window {
        Featurebase: (((...args: unknown[]) => void) | undefined) & { q?: Array<unknown> };
    }
}

const SDK_ID = "featurebase-sdk";
const SDK_URL = "https://do.featurebase.app/js/sdk.js";

// The parent-page SDK exists only to identify the account towards the embedded
// feedback widget (which loads its own SDK copy inside its iframe), so it is
// injected on first use instead of at page load.
function ensureSdk() {
    if (typeof window.Featurebase !== "function") {
        window.Featurebase = function (...args: unknown[]) {
            (window.Featurebase.q = window.Featurebase.q || []).push(args);
        };
    }

    if (document.getElementById(SDK_ID)) {
        return;
    }

    const script = document.createElement("script");
    script.id = SDK_ID;
    script.src = SDK_URL;
    script.async = true;
    document.head.appendChild(script);
}

export function featurebaseAuthenticate(params: {
    accountId: number;
    firstName: string;
    lastName: string;
    email?: string;
    id: number;
    featurebaseUserHash?: string;
    companyId?: number;
    companyName?: string;
}) {
    ensureSdk();

    window.Featurebase(
        "identify",
        {
            organization: "pentacode",
            id: params.accountId.toString(),
            name: `${params.firstName.slice(0, 1)}. ${params.lastName}`,
            email: params.email,
            userHash: params.featurebaseUserHash,
            customFields: {
                fullName: params.firstName + " " + params.lastName,
            },
            companies: [
                {
                    id: params.companyId?.toString(),
                    name: `${params.companyName} (${params.companyId})`,
                },
            ],
        },
        (err: unknown) => {
            if (err) {
                console.error(err);
            }
        }
    );
}
